// extracted by css-extract-rspack-plugin
export default {"trigger":"vvjhSWeVtQabuiUF"};